import React, { useCallback, useEffect, useRef, useState } from 'react';
import './find-results.scss';
import { Button, ContextMenu, DataGrid, Popup, Tooltip } from 'devextreme-react';
import { CreateOrders, PdfIcon, UnPdfIcon, xrayIcon } from '../../images/icons';
import { RightPanel } from '../../components/utils/right-panel/RighPanel';
import { useAppDispatch, useAppSelector } from '../../contexts/hooks';
import { shallowEqual } from 'react-redux';
import { InfoPanelOrder } from '../../components/utils/info-panels/InfoPanelOrder';
import { InfoPanelPatient } from '../../components/utils/info-panels/InfoPanelPatient';
import { FilterComponent } from './Modals/FilterOrders';
import { useApiSearch } from '../../api/api.Search';
import { Column, FilterRow, HeaderFilter, Item, Paging, Scrolling, Selection, Toolbar } from 'devextreme-react/data-grid';
import moment from 'moment';
import { ConvertDataPatient, ConvertDataOrder, ConvertLocalDate } from '../../utils/functions';
import { Pin, resButtonRefresh, resButtonsMail, resButtonsPrint, UnPin } from '../../images/icons';
import { newToast } from '../../components';
import { SendMailResuls } from '../../components/library/info-order/OrderModules/modals/SendMailResuls';
import { setPanelPined, setPanelVisible } from '../../contexts/slices/orders';
import { ModalReportResults } from '../../components/library/reporting/ModalReportResults';
import { useApiStorage } from '../../api/api.Storage';
import { useApiOrders } from '../../api/api.orders';
import { TypeTableFilter } from '../../types/types.system';
import { UseApiResults } from '../../api/api.results';
import DicomViewer from '../../components/utils/dicom-viewer/DicomViewer';
import { LoadIndicator } from 'devextreme-react/load-indicator';
import List from 'devextreme-react/list';
import { useScreenSize } from '../../utils/media-query';

const Index = () => {
  const ColumnsContainerOrderOrders = useAppSelector((x) => x.configuration.Data?.Config_General.filter((x) => x.Cgn_Nombre === 'ColumnsContainerOrderOrders')[0], shallowEqual)?.Cgn_Resultado;
  const ColumnsContainerPatientOrders = useAppSelector((x) => x.configuration.Data?.Config_General.filter((x) => x.Cgn_Nombre === 'ColumnsContainerPatientOrders')[0], shallowEqual)?.Cgn_Resultado;
  const [data, setData] = React.useState<any[]>([]);
  const [modalVisible, setModalVisible] = React.useState(false);
  const { SearchOrder, GetOrderById } = useApiSearch();
  const gridRef = useRef<DataGrid>(null);
  const griResdRef = useRef<DataGrid>(null);
  const [currentDataStudie, setCurrentDataStudie] = React.useState<any>(null);
  const [currentOrder, setCurrentOrder] = React.useState<any>(null);
  const [currentPatient, setCurrentPatient] = React.useState<any>(null);
  const [modalSendMail, setModalSendMail] = useState<{ visible: boolean; studies?: number[] | undefined }>({ visible: false });
  const [modalPrintResult, setModalPrintResult] = useState<{ visible: boolean; studies?: number[] | undefined }>({ visible: false });
  const Prm_ResImprimir = useAppSelector((x) => x.userInfo.Permissions?.Prm_ResImprimir, shallowEqual) ?? false;
  const Prm_Res_Mail = useAppSelector((x) => x.userInfo.Permissions?.Prm_Res_Mail, shallowEqual) ?? false;
  const Prm_Ord = useAppSelector((x) => x.userInfo.Permissions?.Prm_Ord, shallowEqual) ?? false;
  const ModuleEmail: boolean = JSON.parse(useAppSelector((x) => x.configuration.Data?.Config_General.filter((x) => x.Cgn_Nombre === 'ModuleEmail')[0].Cgn_Resultado, shallowEqual) || 'false');
  const panelVisible = useAppSelector((x) => x.globalOrders.PanelVisible, shallowEqual);
  const dispatch = useAppDispatch();
  const { GetFile } = useApiStorage();
  const [showPdfPopup, setShowPdfPopup] = useState(false);
  // Visor de adjuntos: soporta uno o varios archivos por estudio (apilados)
  const [viewerFiles, setViewerFiles] = useState<{ id: number; url: string | null }[]>([]);
  const [viewerLoading, setViewerLoading] = useState(false);
  const [viewerIndex, setViewerIndex] = useState(0);
  const { findOrder } = useApiOrders();
  const [loading, setLoading] = useState<boolean>(false);
  const [searchDocument, setSearchDocument] = useState<string>('');
  const { getResults, getDxImageUrl } = UseApiResults();
  const [dicomPopup, setDicomPopup] = useState<{ visible: boolean; imageUrls: string[]; title: string }>({ visible: false, imageUrls: [], title: '' });
  const [dicomReady, setDicomReady] = useState<boolean>(false);
  const [analyteSelectionPopup, setAnalyteSelectionPopup] = useState<{ visible: boolean; analytes: any[] }>({ visible: false, analytes: [] });
  const [loadingDicom, setLoadingDicom] = useState<boolean>(false);
  const { isLarge, isMedium } = useScreenSize();
  // En pantallas medianas/grandes el panel de órdenes queda fijo (no se puede ocultar).
  const lockPanel = isLarge || isMedium;

  const handleDxImageClick = useCallback(
    async (studyData: any) => {
      if (!currentOrder) {
        newToast('INFO', 'No hay orden seleccionada', 3);
        return;
      }

      setLoadingDicom(true);
      try {
        const results = await getResults(currentOrder.Ord_Id, { studies: [studyData.Res_Es_Id], states: [3, 4, 5], areas:[],  });
        if (!results || results.length === 0) {
          newToast('INFO', 'No se encontraron resultados para este estudio', 3);
          return;
        }

        // Filtrar analitos con An_Tr_Id === 12, Res_Estado >= 3 y que tengan imagenDx
        const dxAnalytes = results.filter((r: any) => {
          if (r.Analito?.An_Tr_Id !== 12 || r.Res_Estado < 3) return false;
          try {
            const parsed = JSON.parse(r.Res_Resultado);
            if (!parsed?.imagenDx) return false;
            // Soportar tanto string (legacy) como array
            if (Array.isArray(parsed.imagenDx)) return parsed.imagenDx.length > 0;
            return typeof parsed.imagenDx === 'string' && parsed.imagenDx !== '';
          } catch {
            return false;
          }
        });

        if (dxAnalytes.length === 0) {
          newToast('INFO', 'No hay imágenes diagnósticas disponibles para este estudio', 3);
          return;
        }

        if (dxAnalytes.length === 1) {
          // Solo un analito, abrir directamente
          const parsed = JSON.parse(dxAnalytes[0].Res_Resultado);
          const fileNames: string[] = Array.isArray(parsed.imagenDx) ? parsed.imagenDx : [parsed.imagenDx];
          const urls: string[] = [];
          for (const fn of fileNames) {
            const url = await getDxImageUrl(fn);
            if (url) urls.push(url);
          }
          if (urls.length > 0) {
            setDicomPopup({ visible: true, imageUrls: urls, title: dxAnalytes[0].Analito?.An_Nombre || 'Imagen diagnóstica' });
          } else {
            newToast('ERROR', 'No se pudo obtener la URL de la imagen', 3);
          }
        } else {
          // Múltiples analitos, mostrar selector
          const analyteOptions = dxAnalytes.map((r: any) => {
            const parsed = JSON.parse(r.Res_Resultado);
            const fileNames: string[] = Array.isArray(parsed.imagenDx) ? parsed.imagenDx : [parsed.imagenDx];
            return {
              An_Nombre: r.Analito?.An_Nombre || 'Sin nombre',
              imagenDx: fileNames,
              Res_Id: r.Res_Id,
            };
          });
          setAnalyteSelectionPopup({ visible: true, analytes: analyteOptions });
        }
      } catch (err) {
        newToast('ERROR', 'Error al obtener las imágenes diagnósticas', 3);
      } finally {
        setLoadingDicom(false);
      }
    },
    [currentOrder, getResults, getDxImageUrl]
  );

  const handleSelectAnalyte = useCallback(
    async (analyte: any) => {
      setAnalyteSelectionPopup({ visible: false, analytes: [] });
      setLoadingDicom(true);
      try {
        const fileNames: string[] = Array.isArray(analyte.imagenDx) ? analyte.imagenDx : [analyte.imagenDx];
        const urls: string[] = [];
        for (const fn of fileNames) {
          const url = await getDxImageUrl(fn);
          if (url) urls.push(url);
        }
        if (urls.length > 0) {
          setDicomPopup({ visible: true, imageUrls: urls, title: analyte.An_Nombre });
        } else {
          newToast('ERROR', 'No se pudo obtener la URL de la imagen', 3);
        }
      } finally {
        setLoadingDicom(false);
      }
    },
    [getDxImageUrl]
  );

  const handleClickRefresh = () => {
    if (currentOrder) {
      fetchData(currentOrder.Ord_Id);
    }
  };

  const handlePanelClose = () => {
    dispatch(setPanelVisible(true));
    dispatch(setPanelPined(false));
  };

  const handleClickFilter = () => {
    // Logic to filter the data
    setModalVisible(true);
  };

  useEffect(() => {
    const filters = [
      {
        Field: 'Ord_FechaCreacion',
        TypeFilter: 'Between',
        Value: ConvertLocalDate(new Date()),
        Value2: ConvertLocalDate(new Date()),
      },
    ];
    handleApplyFilters(filters);
  }, []);

  const handleClickViewPatient = () => {
    // Logic to view patient details
  };

  const handlePdfClick = async (data) => {
    if (data.TieneAdjuntos !== 1) return;

    // Un estudio puede tener varios adjuntos: se leen desde Oad_Ids (lista) o Oad_Id (compatibilidad).
    let ids: number[] = [];
    if (data.Oad_Ids) {
      ids = String(data.Oad_Ids)
        .split(',')
        .map((s) => parseInt(s.trim(), 10))
        .filter((n) => !isNaN(n));
    } else if (data.Oad_Id) {
      ids = [data.Oad_Id];
    }
    if (ids.length === 0) return;

    setShowPdfPopup(true); // Abrir el modal de inmediato
    setViewerLoading(true);
    setViewerIndex(0);
    setViewerFiles(ids.map((id) => ({ id, url: null })));
    try {
      const results = await Promise.all(
        ids.map(async (id) => {
          try {
            const base64 = await GetFile(id);
            if (base64 && base64.file) {
              const sanitizedBase64 = base64.file.replace(/\s/g, '');
              return { id, url: `data:application/pdf;base64,${sanitizedBase64}` };
            }
          } catch (err) {
            console.error('Error al obtener el archivo:', err);
          }
          return { id, url: null };
        })
      );
      setViewerFiles(results);
    } finally {
      setViewerLoading(false);
    }
  };

  //#region ENVIAR RESULTADOS POR CORREO
  const handleSendMail = useCallback(async () => {
    if (!currentOrder) {
      newToast('INFO', 'No hay orden seleccionada para enviar resultados por correo', 5);
      return;
    }
    const idOrd = currentOrder.Ord_Id;
    if (idOrd === -1) {
      return;
    }
    if (!Prm_Res_Mail) {
      newToast('INFO', 'No cuenta con los permisos para enviar resultados por correo', 5);
      return;
    }
    let info = await griResdRef.current?.instance.getDataSource();
    const data = info?.items();

    if (!data || data.length === 0) {
      newToast('INFO', 'No hay resultados para enviar por correo', 5);
      return;
    }
    //Eliminamos los resultados que no están en estado 2
    const infoFiltered = data.filter((x) => x.PorcentajeValidacion > 0);
    if (infoFiltered.length === 0) {
      newToast('INFO', 'No hay analitos validados para la orden seleccionada', 5);
      return;
    }
    setModalSendMail({ visible: true, studies: undefined });
  }, [setModalSendMail, currentOrder]);

  const handleSendMailSelected = useCallback(async () => {
    if (!currentOrder) {
      newToast('INFO', 'No hay orden seleccionada para enviar resultados por correo', 5);
      return;
    }
    const idOrd = currentOrder.Ord_Id;
    if (idOrd === -1) {
      return;
    }
    if (idOrd === -1) {
      return;
    }
    if (!Prm_Res_Mail) {
      newToast('INFO', 'No cuenta con los permisos para enviar resultados por correo', 5);
      return;
    }

    try {
      let info = await griResdRef.current?.instance.getSelectedRowsData();
      if (!info || info.length === 0) {
        newToast('INFO', 'No hay resultados seleccionados para enviar por correo', 5);
        return;
      }

      info = info.filter((x) => x.PorcentajeValidacion > 0);
      if (info.length === 0) {
        newToast('INFO', 'No hay analitos validados para los estudios seleccionados', 5);
        return;
      }
      //Sacamos los estudios seleccionados
      const selectedStudies: number[] = [];
      const uniqueMap: { [key: number]: boolean } = {};

      info.forEach((obj) => {
        if (!uniqueMap[obj.Res_Es_Id]) {
          uniqueMap[obj.Res_Es_Id] = true;
          selectedStudies.push(obj.Res_Es_Id);
        }
      });
      setModalSendMail({ visible: true, studies: selectedStudies });
    } finally {
      await gridRef.current?.instance.endCustomLoading();
    }
  }, [currentOrder]);

  const handleCloseModalSendMail = useCallback(() => {
    setModalSendMail({ visible: false, studies: undefined });
    griResdRef.current?.instance.clearSelection();
  }, [setModalSendMail]);

  //#endregion

  //#endregion IMPRIMIR
  const handlePrintResults = useCallback(async () => {
    if (!currentOrder) {
      newToast('INFO', 'No hay orden seleccionada para enviar resultados por correo', 5);
      return;
    }
    const idOrd = currentOrder.Ord_Id;
    if (idOrd === -1) {
      return;
    }
    if (!Prm_ResImprimir) {
      newToast('INFO', 'No cuenta con los permisos para imprimir resultados', 5);
      return;
    }
    let info = await griResdRef.current?.instance.getDataSource();
    const data = info?.items();

    if (!data || data.length === 0) {
      newToast('INFO', 'No hay resultados para imprimir', 5);
      return;
    }
    //Eliminamos los resultados que no están en estado 2
    const infoFiltered = data.filter((x) => x.PorcentajeValidacion > 0);
    if (infoFiltered.length === 0) {
      newToast('INFO', 'No hay analitos validados para esta orden', 5);
      return;
    }
    setModalPrintResult({ visible: true });
  }, [currentOrder, setModalPrintResult, griResdRef]);

  const handlePrintResultsSelected = useCallback(async () => {
    if (!currentOrder) {
      newToast('INFO', 'No hay orden seleccionada para enviar resultados por correo', 5);
      return;
    }
    const idOrd = currentOrder.Ord_Id;
    if (idOrd === -1) {
      return;
    }

    if (!Prm_ResImprimir) {
      newToast('INFO', 'No cuenta con los permisos para imprimir resultados', 5);
      return;
    }
    try {
      await gridRef.current?.instance.beginCustomLoading('');
      let info = await griResdRef.current?.instance.getSelectedRowsData(); //Eliminamos los resultados que no están en estado 2
      if (!info || info.length === 0) {
        newToast('INFO', 'No hay resultados seleccionados imprimir', 5);
        return;
      }

      info = info.filter((x) => x.PorcentajeValidacion > 0);
      if (info.length === 0) {
        newToast('INFO', 'No hay analitos validados para los estudios seleccionados', 5);
        return;
      }
      //Sacamos los estudios seleccionados
      const selectedStudies: number[] = [];
      const uniqueMap: { [key: number]: boolean } = {};

      info.forEach((obj) => {
        if (!uniqueMap[obj.Res_Es_Id]) {
          uniqueMap[obj.Res_Es_Id] = true;
          selectedStudies.push(obj.Res_Es_Id);
        }
      });
      setModalPrintResult({ visible: true, studies: selectedStudies });
    } finally {
      await gridRef.current?.instance.endCustomLoading();
    }
  }, [currentOrder]);
  //#endregion

  const handleApplyFilters = (filters) => {
    setModalVisible(false);
    SearchOrder(filters).then((res) => {
      if (res.length > 0) {
        setData(res);
      } else {
        setData([]);
      }
    });
  };

  const handleSearchByDocument = useCallback(
    (document: string) => {
      if (!document || document.trim() === '') {
        newToast('INFO', 'Por favor ingrese un documento para buscar', 3);
        return;
      }
      const filters = [
        {
          Field: 'Pc_Identificacion',
          TypeFilter: TypeTableFilter.Equal,
          Value: document.trim(),
        },
      ];
      SearchOrder(filters).then((res) => {
        if (res.length > 0) {
          setData(res);
          setSearchDocument(''); // Limpiar el campo después de buscar
        } else {
          setData([]);
          newToast('INFO', 'No se encontraron resultados para el documento ingresado', 3);
        }
      });
    },
    [SearchOrder]
  );

  const handleCloseModal = () => {
    setModalVisible(false);
    //Eliminar la selección de la grilla
  };

  const handleFocusedRowChanged = (e) => {
    const selectedRow = e.row.data; // Aquí accedemos a la fila seleccionada

    if (selectedRow) {
      // Si la fila es válida, obtenemos su ID y ejecutamos `findOrder`
      const rowId = selectedRow.Ord_Id;
      fetchData(rowId);
    }
  };

  const fetchData = useCallback(
    async (idOrd) => {
      GetOrderById(idOrd).then((res) => {
        if (res) {
          const { Orden, Paciente, Estudios } = res;
          const convertedData = ConvertDataPatient(Paciente);
          const convertedOrder = ConvertDataOrder(Orden);
          setCurrentPatient(convertedData);
          setCurrentOrder(convertedOrder);
          setCurrentDataStudie(Estudios);

          //setCurrentOrder(res);
        } else {
          setCurrentOrder(null);
        }
      });
    },
    [setCurrentPatient, setCurrentOrder, setCurrentDataStudie]
  );

  const rowPrepared = (e) => {
    if (e.rowType === 'data') {
      const color = e.data.Se_Color;
      if (color && color.trim() !== '') {
        e.rowElement.style.color = color;
      }
      e.rowElement.setAttribute('id', `row-${e.data.Ord_Id}`);
    }
  };

  const handleClosePdfPopup = () => {
    setShowPdfPopup(false);
    setViewerFiles([]);
  };

  const handleClickViewOrder = () => {
    if (currentOrder) {
      findOrder(undefined, currentOrder.Ord_Id, setLoading, true);
    } else {
      newToast('INFO', 'Seleccione una orden', 5);
    }
  };

  return (
    <div className='view crm-contact-list'>
      <div className='view-wrapper-contact-list'>
        <div style={{ width: '100%', height: 'calc(100vh - 100px)' }}>
          <div className='view-wrapper view-wrapper-contact-details'>
            <div className='container-forms-ord'>
              <div className={`colOrd-${ColumnsContainerOrderOrders ? ColumnsContainerOrderOrders : 6}`}>
                <InfoPanelOrder OrdertData={currentOrder} ModuleName='Buscar ordenes' handleClickFilter={handleClickFilter} handleClickRefresh={handleClickRefresh} searchDocument={searchDocument} onSearchDocumentChange={setSearchDocument} onSearchByDocument={handleSearchByDocument} />
              </div>
              <div className={`colOrd-${ColumnsContainerPatientOrders ? ColumnsContainerPatientOrders : 6}`}>
                <InfoPanelPatient PatientData={currentPatient} handleClickViewPatient={handleClickViewPatient} />
              </div>
            </div>
            <div className='detail-values-container'>
              <DataGrid className='grid' dataSource={currentDataStudie} ref={griResdRef} hoverStateEnabled={true} height='calc(100vh - 300px)' repaintChangesOnly={true} highlightChanges={true} rowAlternationEnabled={true} showColumnLines={true}>
                <Selection mode='multiple' />
                <Scrolling mode='virtual' />
                <Toolbar>
                  <Item location='before' visible={currentDataStudie}>
                    <span className='title-text'>{currentDataStudie?.length || 0} Estudios</span>
                  </Item>
                  <Item location='after' locateInMenu='auto' visible={Prm_Ord} showText='inMenu' widget='dxButton'>
                    <Button id='ViewOrder' icon={CreateOrders} text='Ver orden' onClick={handleClickViewOrder} stylingMode='text' />
                    <Tooltip target={'#ViewOrder'} showEvent='mouseenter' hideEvent='mouseleave' position={'top'}>
                      Ver orden
                    </Tooltip>
                  </Item>
                  <Item location='after' locateInMenu='auto' visible={Prm_ResImprimir} showText='inMenu' widget='dxButton'>
                    <Button id='ImprimirResult' icon={resButtonsPrint} text='Imprimir resultados' stylingMode='text' onClick={handlePrintResults} />
                    <ContextMenu width={'auto'} target={'#ImprimirResult'} dataSource={[{ text: 'Imprimir estudios seleccionados', icon: resButtonsPrint }]} onItemClick={handlePrintResultsSelected} />
                    <Tooltip target={'#ImprimirResult'} showEvent='mouseenter' hideEvent='mouseleave' position={'top'}>
                      Imprimir resultados
                    </Tooltip>
                  </Item>
                  <Item location='after' visible={ModuleEmail && Prm_Res_Mail} locateInMenu='auto' showText='inMenu' widget='dxButton'>
                    <Button id='EnviarResultMail' icon={resButtonsMail} text='Enviar resultados por correo' stylingMode='text' onClick={handleSendMail} />
                    <ContextMenu width={'auto'} target={'#EnviarResultMail'} dataSource={[{ text: 'Enviar estudios seleccionados', icon: resButtonsMail }]} onItemClick={handleSendMailSelected} />
                    <Tooltip target={'#EnviarResultMail'} showEvent='mouseenter' hideEvent='mouseleave' position={'top'}>
                      Enviar resultados por correo
                    </Tooltip>
                  </Item>
                  <Item location='after' locateInMenu='auto' showText='inMenu' widget='dxButton'>
                    <Button id='RefrecarResult' icon={resButtonRefresh} text='Refresh' stylingMode='text' onClick={handleClickRefresh} />
                    <Tooltip target={'#RefrecarResult'} showEvent='mouseenter' hideEvent='mouseleave' position={'top'}>
                      Refrescar datos
                    </Tooltip>
                  </Item>
                  <Item location='after' locateInMenu='never' showText='inMenu' widget='dxButton' visible={!lockPanel}>
                    <Button id='showpanel' icon={panelVisible ? Pin : UnPin} text={panelVisible ? 'Panel Visible' : 'Panel oculto'} stylingMode='text' onClick={handlePanelClose} />
                    <Tooltip target={'#showpanel'} showEvent='mouseenter' hideEvent='mouseleave' position={'top'}>
                      {panelVisible ? 'Ocultar panel' : 'Abrir panel'}
                    </Tooltip>
                  </Item>
                </Toolbar>
                <Column dataField='Es_Id' caption='Id' visible={false} />
                <Column
                  caption='ESTUDIO'
                  dataField='Es_Nombre'
                  allowFiltering
                  cellRender={(cellData) => {
                    const hasImages = cellData.data.Imagenes === 1;
                    return (
                      <div className='study-cell'>
                        <span>{cellData.value}</span>
                        {hasImages && (
                          <span id={`imgDiag${cellData.data.Es_Id}`} className='study-image-badge' style={{ cursor: 'pointer' }} onClick={() => handleDxImageClick(cellData.data)}>
                            <img src={xrayIcon} alt='Imágenes' className='study-image-icon' />
                            <Tooltip target={`#imgDiag${cellData.data.Es_Id}`} showEvent='mouseenter' hideEvent='mouseleave' position='top'>
                              Ver imágenes diagnósticas
                            </Tooltip>
                          </span>
                        )}
                      </div>
                    );
                  }}
                />
                <Column
                  dataField='PorcentajeValidacion'
                  caption='% VALIDACIÓN'
                  alignment='center'
                  width={150}
                  cellRender={(data) => {
                    const porcentaje = data.value || 0;
                    return (
                      <div className='meter-container'>
                        <meter value={porcentaje} min={0} max={100} low={1} high={99} optimum={100} className='animated-meter' />
                        <span style={{ fontSize: '12px', fontWeight: '600', minWidth: '35px', color: porcentaje === 100 ? '#4caf50' : porcentaje === 0 ? '#f44336' : '#666' }}>{porcentaje}%</span>
                      </div>
                    );
                  }}
                />
                <Column
                  dataField='TieneAdjuntos'
                  caption='PDF'
                  width={80}
                  alignment='center'
                  cellRender={(data) => {
                    const hasAttachments = data.value === 1;
                    const count = data.row.data.AdjuntosCount || 0;
                    return (
                      <div id={`pdfFile${data.row.data.Res_Es_Id}`} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 4 }}>
                        <img
                          src={hasAttachments ? PdfIcon : UnPdfIcon}
                          alt=''
                          style={{ width: '20px', height: '20px', cursor: hasAttachments ? 'pointer' : 'default' }}
                          onClick={() => {
                            if (hasAttachments) {
                              handlePdfClick(data.row.data);
                            }
                          }}
                        />
                        {count > 1 && (
                          <span
                            style={{ background: '#65ABF2', color: '#fff', borderRadius: '10px', padding: '0 6px', fontSize: '11px', fontWeight: 600, minWidth: 16, textAlign: 'center', lineHeight: '16px' }}
                            title={`${count} archivos adjuntos`}>
                            {count}
                          </span>
                        )}
                        <Tooltip target={`#pdfFile${data.row.data.Res_Es_Id}`} showEvent='mouseenter' hideEvent='mouseleave' position={'top'}>
                          {hasAttachments ? (count > 1 ? `${count} archivos adjuntos` : 'Ver archivo adjunto') : 'Estudio sin adjuntos'}
                        </Tooltip>
                      </div>
                    );
                  }}
                />
              </DataGrid>
            </div>
          </div>
        </div>

        <RightPanel lockOnDesktop={lockPanel}>
          <DataGrid dataSource={data} tabIndex={0} height='100%' onFocusedRowChanged={handleFocusedRowChanged} ref={gridRef} focusedRowEnabled={true} keyExpr='Ord_Id' id='currentOrders' onRowPrepared={rowPrepared} className='gridOrders compact-grid' noDataText='No hay órdenes para mostrar' hoverStateEnabled={true} repaintChangesOnly={true}>
            <Paging enabled={false} />
            <Selection mode='single' />
            <Scrolling mode='virtual' rowRenderingMode='virtual' />
            <FilterRow visible={true} />
            <HeaderFilter visible={true} />
            <Toolbar>
              <Item location='before'>
                <span className='title-text'>{data?.length || 0} Órdenes</span>
              </Item>
              <Item name='searchPanel' location='after' />
            </Toolbar>
            <Column dataField='Ord_Numero' caption='ORDEN' width={100}>
              <HeaderFilter />
            </Column>
            <Column dataField='Pc_Nombre' caption='USUARIO' calculateCellValue={(rowData) => `${rowData.Pc_Nombre || ''} ${rowData.Pc_Apellido1 || ''} ${rowData.Pc_Apellido2 || ''}`} calculateDisplayValue={(rowData) => `${rowData.Pc_Nombre || ''} ${rowData.Pc_Apellido1 || ''} ${rowData.Pc_Apellido2 || ''}`}>
              <HeaderFilter />
            </Column>
          </DataGrid>
        </RightPanel>
      </div>
      {data.map((order) => (
        <Tooltip key={order.Ord_Id} target={`#row-${order.Ord_Id}`} showEvent='mouseenter' hideEvent='mouseleave' position='left'>
          <div className='toolTipFilter'>
            <div>
              <strong>Fecha de creación:</strong> {moment(order.Column1).format('DD/MM/YYYY')}
            </div>
            <div>
              <strong>Orden:</strong> {order.Ord_Numero}
            </div>
            <div>
              <strong>Usuario:</strong> {order.Pc_Nombre || ''} {order.Pc_Apellido1 || ''} {order.Pc_Apellido2 || ''}
            </div>
          </div>
        </Tooltip>
      ))}

      <SendMailResuls visible={modalSendMail.visible} setVisible={handleCloseModalSendMail} lstStudies={modalSendMail.studies} patientData={currentPatient} orderData={currentOrder} />
      {modalPrintResult.visible && <ModalReportResults visible={modalPrintResult.visible} setVisible={setModalPrintResult} studies={modalPrintResult.studies} reportName={'Resultados'} idOrd={currentOrder.Ord_Id} />}
      <FilterComponent onApplyFilters={handleApplyFilters} visible={modalVisible} setVisible={handleCloseModal} includeOrderFields={true} includePatientFields={true} />

      {/* Modal de selección de analito con imágenes Dx */}
      <Popup
        visible={analyteSelectionPopup.visible}
        onHiding={() => setAnalyteSelectionPopup({ visible: false, analytes: [] })}
        showCloseButton
        showTitle={true}
        title='Seleccionar imagen diagnóstica'
        width={400}
        height='auto'
        dragEnabled={false}
      >
        <div className='analyte-selection-container'>
          <p className='analyte-selection-hint'>Este estudio tiene múltiples imágenes diagnósticas. Seleccione cuál desea visualizar:</p>
          <List
            dataSource={analyteSelectionPopup.analytes}
            displayExpr='An_Nombre'
            onItemClick={(e) => handleSelectAnalyte(e.itemData)}
            itemRender={(item) => (
              <div className='analyte-selection-item'>
                <img src={xrayIcon} alt='' className='study-image-icon' />
                <span>{item.An_Nombre}</span>
              </div>
            )}
          />
        </div>
      </Popup>

      {/* Modal del visor DICOM */}
      <Popup
        visible={dicomPopup.visible}
        onHiding={() => setDicomPopup({ visible: false, imageUrls: [], title: '' })}
        onShown={() => setDicomReady(true)}
        onHidden={() => setDicomReady(false)}
        showCloseButton
        showTitle={true}
        title={`Imagen diagnóstica - ${dicomPopup.title}`}
        fullScreen
        dragEnabled
      >
        {dicomReady && dicomPopup.imageUrls.length > 0 ? <DicomViewer imageIds={dicomPopup.imageUrls} /> : <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', gap: '10px' }}><LoadIndicator visible={true} height={40} width={40} /><span>Cargando visor...</span></div>}
      </Popup>

      {/* Loading indicator para carga de imágenes Dx */}
      <Popup visible={loadingDicom} showTitle={false} showCloseButton={false} width={200} height={100} dragEnabled={false} shading={true}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px', height: '100%' }}>
          <LoadIndicator visible={true} height={30} width={30} />
          <span>Cargando...</span>
        </div>
      </Popup>

      <Popup visible={showPdfPopup} onHiding={handleClosePdfPopup} onHidden={handleClosePdfPopup} showCloseButton showTitle={true} title='Vista previa del archivo' fullScreen dragEnabled>
        {viewerLoading && viewerFiles.every((f) => !f.url) ? (
          <div style={{ textAlign: 'center', marginTop: '20px' }}>Cargando documento...</div>
        ) : viewerFiles.length === 0 ? (
          <div style={{ textAlign: 'center', marginTop: '20px' }}>No hay archivos para mostrar.</div>
        ) : (
          (() => {
            const idx = Math.min(viewerIndex, viewerFiles.length - 1);
            const current = viewerFiles[idx];
            const multiple = viewerFiles.length > 1;
            return (
              <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                {multiple && (
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, padding: '6px 10px', background: '#f5f5f5' }}>
                    <Button icon='chevronleft' stylingMode='text' disabled={idx === 0} onClick={() => setViewerIndex(Math.max(0, idx - 1))} />
                    <span style={{ fontSize: 13, fontWeight: 600 }}>
                      Archivo {idx + 1} / {viewerFiles.length}
                    </span>
                    <Button icon='chevronright' stylingMode='text' disabled={idx >= viewerFiles.length - 1} onClick={() => setViewerIndex(Math.min(viewerFiles.length - 1, idx + 1))} />
                  </div>
                )}
                <div style={{ flex: 1, minHeight: 0 }}>
                  {current.url ? (
                    <object data={current.url} type='application/pdf' width='100%' height='100%' style={{ display: 'block' }}>
                      <p>
                        Tu navegador no soporta la visualización de PDF.{' '}
                        <a href={current.url} target='_blank' rel='noopener noreferrer'>
                          Haz clic aquí para descargarlo
                        </a>
                        .
                      </p>
                    </object>
                  ) : (
                    <div style={{ textAlign: 'center', padding: 20, color: '#f44336' }}>No se pudo cargar este archivo.</div>
                  )}
                </div>
              </div>
            );
          })()
        )}
      </Popup>
    </div>
  );
};

export default Index;
